import Immutable from 'immutable';

const IdpListRecord = Immutable.Record({
  id: undefined,
  studentId: undefined,
  period: undefined,
  skillResults: undefined,
  status: undefined,
  name: undefined,
  shouldShowSuggestions: undefined,
});

export default class IdpList extends IdpListRecord { }



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/IdpList/model.js